(async function () {
  'use strict';

  var TARGET            = 'https://bd.gulahmedshop.com';
  var REDIRECT_COUNTRY  = 'BD';
  var SESSION_COOKIE    = 'geo_checked';
  var START_DELAY_MS    = 100;

  // ---- 0. Wait for full page load, then a further 3 seconds -------------
  if (document.readyState !== 'complete') {
    await new Promise(function (resolve) {
      window.addEventListener('load', resolve, { once: true });
    });
  }
  await new Promise(function (resolve) { setTimeout(resolve, START_DELAY_MS); });

  // ---- 1. Search engine crawlers pass through untouched -------------------
  var BOTS = /bot|crawl|spider|slurp|googlebot|bingbot|duckduckbot|baiduspider|yandex|facebookexternalhit|twitterbot|linkedinbot|whatsapp|applebot|petalbot|ahrefs|semrush|screaming frog|lighthouse|gtmetrix|pingdom/i;
  if (BOTS.test(navigator.userAgent)) return;

  // ---- 2. Never interrupt checkout, cart, account or Shopify internals ----
  var SAFE_PATHS = [
    '/checkout', '/cart', '/account', '/apps', '/a/', '/tools',
    '/services', '/wpm', '/cdn', '/admin', '/.well-known'
  ];
  var path = window.location.pathname;
  for (var i = 0; i < SAFE_PATHS.length; i++) {
    if (path.indexOf(SAFE_PATHS[i]) === 0) return;
  }


  if(document.cookie.indexOf('geo_redirection=1') !== -1 || document.cookie.indexOf('country='+REDIRECT_COUNTRY) !== -1 )
  {
      window.location.replace(TARGET + path + window.location.search);
      return;
  };
  // ---- 3. Respect manual override; don't re-check every page view --------
  if (document.cookie.indexOf('geo_override=1') !== -1) return;
  if (document.cookie.indexOf(SESSION_COOKIE + '=1') !== -1) return;

  // ---- 4. Ask Shopify which country the visitor is in --------------------
  try {
    var res = await fetch('/browsing_context_suggestions.json?source=geolocation_recommendation&country[enabled]=true', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });
    var data = res.ok ? await res.json() : null;

    // Mark as checked regardless of outcome, so this runs once per session
    document.cookie = SESSION_COOKIE + '=1; path=/; max-age=1800; SameSite=Lax';

    if (!data || !data.detected_values || !data.detected_values.country) return;

    var country = data.detected_values.country.handle;
    if (country !== REDIRECT_COUNTRY) return;
    document.cookie = 'country='+country+'; geo_redirection=1; path=/; max-age=1800; SameSite=Lax';
    window.location.replace(TARGET + path + window.location.search);
  } catch (e) {
    // Fail open — if detection fails, the visitor simply stays put
  }
})();